import { useEffect, useState } from 'react';
import messages from '../../statics/messages.json'
import { contacts } from '../../context/CommonContex';
const Contact= ()=>{
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [nextPage, setNextPage] = useState(true);
    const [prevPage, setPrevPage] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchTerm,setSearchTerm] = useState(null);
    const fetchContacts = async (sync) => {
        try {
           
            debugger
            setLoading(true)
            const contactsData = await contacts(currentPage,itemsPerPage,sync,'Contacts',searchTerm);
            if(contactsData != undefined && contactsData != null){
                setCustomers(contactsData.data); 
                setTotalRecords(contactsData.info.count);
                if(contactsData.info && !contactsData.info.more_records){
                    setNextPage(false)
                    setPrevPage(true)
                }else{
                    setNextPage(true)
                    setPrevPage(true)
                }

                if(contactsData.info && contactsData.info.page == 1){
                    setPrevPage(false)
                }else{
                    setPrevPage(true)
                }
            }

            setLoading(false)
            
        } catch (error) {
            console.error("Error fetching contacts:", error);
        }
    };

    useEffect(() => {
        setLoading(true);
        fetchContacts(false); // Call the async function
        setLoading(false);
    }, [currentPage, itemsPerPage,searchTerm]);

    const searchOrder = (value) => {
        setSearchTerm(value);
        setCurrentPage(1); // Reset to first page on new search
    };

    const totalPages = Math.ceil(totalRecords / itemsPerPage);

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const [showModal, setShowModal] = useState(false);
    const [isSyncing, setIsSyncing] = useState(false);

    const handleSync = async () => {
        setIsSyncing(true);
        setShowModal(false); // Close the modal
        try {
            await fetchContacts(true); // Call the fetchContacts function
            
        } catch (error) {
            console.error('Sync failed:', error);
            alert('Sync failed. Please try again.');
        } finally {
            setIsSyncing(false); // Stop loading spinner
        }
    };
    return(
        <div className="box-body border b-white rounded-2">        
        <h4 className="p-2 m-0 border-bottom">Contacts List</h4>
        <div className="row p-2">
            <div className="col-1 d-flex justify-content-start align-items-bottom ">
                <select className="px-3 py-1 border rounded-1 d-inline"
                 onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                }}
                >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                </select>
            </div>
            <div className="col-7"></div>
            <div className="col-1 p-0">
                {/* <button class="btn btn-primary w-100" onClick={() => fetchContacts(true)}>Sync</button>*/}
                 <button className="btn btn-primary w-100" onClick={() => setShowModal(true)}>Sync</button>
            </div> 
            <div className="col-3">
                <input type="text" className="form-control"
                    onInput={(e) => {
                        const value = e.target.value;
                        if (value.length > 3 || value.length ==0) {
                          searchOrder(value);
                        }
                      }}
                placeholder={messages.search_label}/>
            </div>
            </div>
            <div className='row px-2 mt-2 over-flow-table'>
            <div className='col-12 py-0'>
               {isSyncing || loading ? (
                <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1050, // Ensure it overlays all content
                }}
            >
                <div
                    style={{
                        width: '50px',
                        height: '50px',
                        backgroundColor: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '8px', // Optional for rounded edges
                    }}
                >
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
                ) : (
                    
                <table className="table border rounded">
                    <thead className='table-sticky-head'>
                        <tr>
                            <th className="text-center">{messages.contact_name_lable}</th>
                            <th className="text-center">{messages.company_name_label}</th>
                            <th className="text-center">{messages.company_owner_label}</th>
                            <th className="text-center">{messages.title_label}</th>
                            <th className="text-center">{messages.email_label}</th>
                            <th className="text-center">{messages.phone_label}</th>
                            <th className="text-center">{messages.tag_label}</th>
                            <th className="text-center">{messages.year_est_label}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {customers && customers.length > 0 ? (
                            customers.map((cust, index) => (
                                <tr key={index}>
                                    <td>{cust.Last_Name}</td>
                                    <td>{cust.Account_Name.name}</td>
                                    <td>{cust.Owner.name}</td>
                                    <td>{cust.Title}</td>
                                    <td>{cust.Email}</td>
                                    <td>{cust.Phone}</td>
                                    <td>{cust.Tag.name}</td>
                                    <td>{cust.Year_Established}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className='text-center'>No data available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
            </div>
            <div className="col-12 py-2">
                    <nav aria-label="Page navigation example">
                        <span>
                            Showing {((currentPage - 1) * itemsPerPage) + 1} to {((currentPage - 1) * itemsPerPage) + totalRecords}
                        </span>
                        <ul className="pagination float-end">
                           {prevPage?(
                                <li className={`page-item`}>
                                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
                                </li>
                           ):('')}
                            {[...Array(totalPages)].map((_, index) => (
                                <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(index + 1)}>{currentPage}</button>
                                </li>
                            ))}
                            {nextPage?(
                                 <li className={`page-item `}>
                                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                                </li>
                           ):('')}
                           
                        </ul>
                    </nav>
                </div>
        </div>

        {showModal && (
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog" style={{marginTop:'200px'}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Sync</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <p>Do you want to sync the data?</p>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                                <button className="btn btn-primary" onClick={handleSync}>Sync Data</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        
        </div>

    )
}

export default Contact;